<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Rijschool in Den Haag nodig?</h1>
      <p>
        Ben je bijna zover dat je eindelijk autorijlessen mag gaan volgen? Heb
        je al een autorijbewijs, maar zou je daar wel een motorrijbewijs aan
        willen toevoegen? Zou je, met het oog op je werk, graag je vrachtwagen-
        of busrijbewijs willen behalen? Welke reden je ook hebt om een rijschool
        in Den Haag te zoeken: via Rijscholenvergelijker.nl kom je rechtstreeks
        in contact met de beste rijscholen van Den Haag en omgeving. Je hoeft er
        nauwelijks iets voor te doen: je vult slechts enkele gegevens over
        jezelf in op de website en wij zorgen ervoor dat de
        <nuxt-link to="/"> rijscholen </nuxt-link> in jouw regio de volgende dag
        al contact opnemen. En dat helemaal gratis en zonder ergens aan vast te
        zitten!
      </p>

      <h2>Bespaar honderden euro’s!</h2>
      <p>
        Een goede rijschool in Den Haag kan je tot honderden euro’s opleveren.
        Dat verschil zit ‘m niet alleen in het uurtarief, maar zeker ook in het
        aantal uren dat kandidaten bij de betreffende rijschool gemiddeld nodig
        hebben voordat ze met succes hun praktijkexamen hebben afgelegd. Laat je
        daarom goed informeren door verschillende rijscholen rond Den Haag en
        vraag behalve het uurtarief bijvoorbeeld naar het slagingspercentage en
        de hoeveelheid lesuren die leerlingen gemiddeld behoeven. Daarnaast
        heeft iedereen natuurlijk andere eisen: misschien wil je graag weten hoe
        het zit met de lesopbouw, of zou je graag theorielessen willen volgen.
        Verdiep je van tevoren goed in de criteria die voor jou belangrijk zijn
        en kies op basis daarvan voor de beste rijschool in Den Haag!
      </p>

      <h2>Rijscholen in Den Haag benaderen jou</h2>
      <p>
        Rijscholenvergelijker.nl helpt je een handje en zorgt ervoor dat de
        rijscholen in Den Haag jou zo snel mogelijk benaderen. Vul dus snel je
        gegevens in, zorg ervoor dat je niet in zee gaat met de eerste de beste
        rijschool in Den Haag en bespaar uiteindelijk honderden euro’s op het
        behalen van je rijbewijs!
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle:
        'Rijschool in Den Haag nodig? Kijk op Rijscholenvergelijker.nl!',
      headDescription:
        'Wie op zoek is naar een rijschool in Den Haag, heeft altijd succes op Rijscholenvergelijker.nl. Laat rijscholen in jouw omgeving contact opnemen!',
    }
  },
}
</script>
